"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./dashboard.routes";

export class DashboardComponent {
  isAdmin = false;
  incidents = [];
  seasons = [];

  textTitle =
    "Search for Title, Descriptions, Responsible Guide, Location Patient (Name, Desc, Injury, Assessment), EMBC Task Number, WSBC Number, Internal Tracking Number";
  filter = {
    season: undefined
  };
  order = {
    field: "date",
    direction: true
  };

  /*@ngInject*/
  constructor($http, appConfig, $uibModal, $filter, Auth) {
    "ngInject";

    this.Auth = Auth;
    this.$uibModal = $uibModal;
    this.$http = $http;
    this.$filter = $filter;
    this.incidentType = appConfig.incidentType;
    this.severities = appConfig.severities;

    let now = this.getCurrentSeason();
    console.log(now);
    for (let year = now; year >= 1960; year--) {
      this.seasons.push(year);
    }
  }

  $onInit() {
    this.Auth.hasRole("admin").then(hasRole => {
      this.isAdmin = hasRole;
      this.filter.season = this.getCurrentSeason();
      this.updateResults();
    });
  }

  getCurrentSeason() {
    const now = new Date();
    let year = now.getFullYear();
    const month = now.getMonth() + 1;
    console.log("month:", month);
    console.log(year, month);

    if (month > 9) year++;

    return year;
  }

  switchPrivateCommunity() {
    this.textTitle =
      this.filter.privacyLevel === "Shared"
        ? "Search for Title, Shared Description"
        : "Search for Title, Descriptions, Responsible Guide, Location Patient (Name, Desc, Injury, Assessment), EMBC Task Number, WSBC Number, Internal Tracking Number";

    this.filter.search = "";
    this.updateResults();
  }

  updateResults() {
    this.$http.post("/api/incidents/dashboard", this.filter).then(response => {
      this.dashboard = response.data;
    });
  }

  sort(field) {
    if (this.order.field == field) {
      this.order.direction = !this.order.direction;
    } else {
      this.order.field = field;
      this.order.direction = false;
    }
  }

  showIncidentDetails(incident) {
    console.log("show details here:", incident);

    const shared = this.isAdmin ? false : this.filter.privacyLevel == "Shared";
    this.$uibModal.open({
      animation: false,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("./incidentDetail.html"),
      controller: "IncidentDetailController",
      controllerAs: "$ctrl",
      resolve: {
        incident() {
          console.log("return incident: ", incident);
          return incident;
        },
        shared() {
          return shared;
        }
      }

      // appendTo: parentElem,
      // resolve: {
      //   items: function () {
      //     return $ctrl.items;
      //   }
      // }
    });
  }

  getDisplayDate(incident) {
    if (incident.date) {
      return this.$filter("date")(incident.date, "mediumDate");
    }
    return incident.season;
  }
}

export default angular
  .module("hccApp.dashboard", [uiRouter])
  .config(routes)
  .component("dashboard", {
    template: require("./dashboard.html"),
    controller: DashboardComponent
    // controllerAs: 'dashboardCtrl'
  }).name;



// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.component.js